import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import { SCOOTER_TYPE_INFO } from 'assets/json/scooterInfo.js'
// Import Swiper styles start
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
// Import Swiper styles end

import TAG_IMG from 'assets/images/scooter/EVC1_belt_tag-07.svg'

/**
 * @file 스마트스쿠터 화면에서 상단의 스쿠터 타입 영역의 swiper
 */
function ScooterTypeSwiper() {
    const settings = {
        className: 'swiper-motors',
        direction: 'horizontal',
        slidesPerView: 4, // 한 화면에 보이는 슬라이드 수
        spaceBetween: 16, // px 단위 간격
        loop: false,
        modules: [Navigation],
        navigation: {
            // 네비게이션 적용, < >
            nextEl: '.motor-btn.next', // 다음 버튼 클래스명
            prevEl: '.motor-btn.prev', // 이전 버튼 클래스명
        },
        breakpoints: {
            100: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            500: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
            // 1048: {
            //     slidesPerView: 6,
            //     spaceBetween: 16,
            // },
        },
    }

    return (
        <Swiper {...settings}>
            {SCOOTER_TYPE_INFO.map((val, index) => (
                <SwiperSlide className="swiper-slide" key={'scooter-box-' + index}>
                    <a href={val.url} className="link">
                        <img className="img-box" src={val.imgUrl} alt="scooter"></img>

                        {val.name === 'EV-C1' && <img className="belt_tag_img" src={TAG_IMG} alt="EV-C1 벨트타입" />}
                        <div className="b1">{val.name}</div>
                    </a>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default ScooterTypeSwiper
